'use client';

import React from 'react';
import { MediaPlayer, MediaProvider, Poster } from '@vidstack/react';
import PopupVideoLayout from '@/components/global/popupVideoLayout/PopupVideoLayout';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import '@vidstack/react/player/styles/default/poster.css';

interface RichtextVideoProps {
  playbackId: string;
  thumbnailUrl?: string;
  description?: string;
}

export function RichtextVideo({ playbackId, thumbnailUrl, description }: RichtextVideoProps) {
  return (
    <div className="lg:my-[6rem] my-[4rem] w-full">
      <div className="relative w-full aspect-video">
        <MediaPlayer
          className="!flex aspect-video"
          autoplay={false}
          src={`https://stream.mux.com/${playbackId}.m3u8?redundant_streams=true`}
          crossOrigin="anonymous"
          streamType="on-demand"
          playsInline
        >
          <MediaProvider />
          <PopupVideoLayout thumbnails={`https://image.mux.com/${playbackId}/storyboard.vtt`} />
          {thumbnailUrl && (
            <Poster className="vds-poster" src={thumbnailUrl} alt="" />
          )}
        </MediaPlayer>
      </div>
      {description && (
        <span className="block mt-[1rem] text-[1.75rem] font-[300] leading-[150%] opacity-70">
          {description}
        </span>
      )}
    </div>
  );
}
